import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@/hooks/useTheme";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "漫画分类", to: "/category" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (kw) {
      navigate(`/category?keyword=${encodeURIComponent(kw)}`);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur shadow-soft border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="container-site flex items-center justify-between h-16 md:h-18">
        <div className="flex items-center gap-8">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
              <i className="ri-book-open-line text-lg"></i>
            </span>
            <span className="font-heading text-2xl text-primary-600 group-hover:text-primary-500 transition-colors">
              漫画网
            </span>
          </Link>
          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.to
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-200"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="flex items-center gap-2">
          <form onSubmit={handleSearch} className="hidden sm:flex items-center gap-2 bg-background-100 border border-background-200 rounded-full px-3 py-2">
            <i className="ri-search-line text-foreground-500 text-sm"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画..."
              className="bg-transparent outline-none text-sm w-32 md:w-44 placeholder:text-foreground-400"
              aria-label="搜索漫画"
            />
          </form>
          <button
            type="button"
            onClick={toggleTheme}
            className="w-9 h-9 rounded-full border border-background-200 bg-background-100 flex items-center justify-center text-foreground-700 hover:bg-background-200 transition-colors"
            aria-label="切换夜间模式"
          >
            <i className={theme === "dark" ? "ri-sun-line" : "ri-moon-line"}></i>
          </button>
          <button
            type="button"
            onClick={() => setOpen(!open)}
            className="md:hidden w-9 h-9 rounded-full border border-background-200 bg-background-100 flex items-center justify-center text-foreground-700"
            aria-label="打开菜单"
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <div className="container-site py-4 flex flex-col gap-2">
            <form onSubmit={handleSearch} className="flex items-center gap-2 bg-background-100 border border-background-200 rounded-full px-3 py-2 sm:hidden">
              <i className="ri-search-line text-foreground-500 text-sm"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画..."
                className="bg-transparent outline-none text-sm flex-1"
                aria-label="搜索漫画"
              />
            </form>
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-3 rounded-lg text-sm font-medium ${
                  location.pathname === link.to
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}